module.exports = __webpack_public_path__ + "static/images/fatal-error.u_Kb0Fe.svg";